"use client";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import useMobileDetect from "@/hooks/useMobileDetect";
import { useEffect, useRef, useState } from "react";
import Image from "next/image";
import Link from "next/link";
import { handleCardClick } from "@/utils/tools";
import ImageWithSkeleton from "@/app/components/common/ImageWithSkeleton";

import "swiper/css";
import "swiper/css/pagination";
import "./style/Carousel.css";

type mediaCardListProps = {
  isFirstMobile?: boolean,
  list: {
    "icon": string,
    "alt_text": string,
    "icon_name": string,
    "link_type"?: number,
    "link"?: string,
    "open_type"?: number,
    "icon_description": string
  }[],
}
export const AdvantageCarousel: React.FC<mediaCardListProps> = ({ isFirstMobile, list }) => {

  const isMobile = useMobileDetect(isFirstMobile);

  const pagination = {
    clickable: true,
  };

  const ListItem = (data: any) => {
    const { icon, alt_text, icon_name, icon_description, link_type, link, open_type } = data
    return <div className="flex flex-col flex-wrap justify-center">
      <div className="rounded-half flex items-center justify-center" style={{ width: "3.4rem", height: "3.4rem" }}>
        <div className="relative" style={{ width: "3.4rem", height: "3.4rem" }}>
          <ImageWithSkeleton
            src={process.env.NEXT_PUBLIC_IMAGE_URL + icon} 
            alt={alt_text}
            width={100} 
            height={100}
          />
        </div>
      </div>
      <h3 className="mt-24 text-3xl leading-30 text-bravve-100 font-medium">{icon_name}</h3>
      <h4 className="mt-24 text-sm leading-22 text-bravve-100">
        {icon_description}
      </h4>
    </div>
  }

  const ListItem_Mobile = (data: any) => {
    const { icon, alt_text, icon_name, icon_description, link_type, link, open_type } = data

    return <div className="flex flex-col flex-wrap justify-center text-center mb-20">
      <div className="rounded-half flex items-center justify-center mx-auto" style={{ width: "3.4rem", height: "3.4rem" }}>
        <div className="relative" style={{ width: "3.4rem", height: "3.4rem" }}>
          <ImageWithSkeleton
            src={process.env.NEXT_PUBLIC_IMAGE_URL + icon} 
            alt={alt_text}
            width={100} 
            height={100}
          />
        </div>
      </div>
      <h3 className="mt-24 text-xl leading-26 text-bravve-100 font-medium">{icon_name}</h3>
      <h4 className="mt-24 text-base leading-22 text-bravve-100">
        {icon_description}
      </h4>
    </div>
  }

  return (
    <>
      {isMobile ? (
        <Swiper
          className="AdvantageCarousel"
          pagination={pagination}
          modules={[Pagination, Autoplay]}
          loop
          autoplay
        >
          {list.map((item, idx: number) => (
            <SwiperSlide key={idx}>
              {handleCardClick({ ...item, idx }, ListItem_Mobile(item), true)}
            </SwiperSlide>
          ))}
        </Swiper>
      ) : (
        <div className="flex justify-between items-stretch">
          {list.map((item, idx: number) => (
            <div key={idx} className="flex justify-between w-full">
              <div>
                {handleCardClick({ ...item, idx }, ListItem(item), false)}
              </div>
              {
                idx === list.length - 1 ? null : <div key={idx + 'line'} className="w-1 bg-[#E5E6EB] mx-60"></div>
              }
            </div>
          ))}
        </div>
      )}
    </>
  );
};
